export type ProductVariant = 'ai' | 'bp' | 'marketplace'

interface VariantStyles {
  background: 'white' | 'gray' | 'dark' | 'gradient'
  title: string
  subtitle: string
  eyebrow: string
  card: string
  cardBorder: string
  cardTitle: string
  cardText: string
  iconBg: string
  iconColor: string
  accentText: string
  accentBorder: string
  accentBg: string
  gradientFrom: string
  gradientTo: string
  checkColor: string
  xColor: string
}

export const productStyles: Record<ProductVariant, VariantStyles> = {
  ai: {
    background: 'dark',
    title: 'text-ink',
    subtitle: 'text-muted',
    eyebrow: 'text-brand-violet',
    card: 'bg-panel',
    cardBorder: 'border-line',
    cardTitle: 'text-ink',
    cardText: 'text-muted',
    iconBg: 'bg-brand-violet-soft',
    iconColor: 'text-brand-violet',
    accentText: 'text-brand-violet',
    accentBorder: 'border-brand-violet-line',
    accentBg: 'bg-brand-violet-soft',
    gradientFrom: 'from-brand-violet-soft',
    gradientTo: 'to-panel',
    checkColor: 'text-white',
    xColor: 'text-red-400',
  },
  bp: {
    background: 'white',
    title: 'text-ink',
    subtitle: 'text-muted',
    eyebrow: 'text-brand-green',
    card: 'bg-panel',
    cardBorder: 'border-line',
    cardTitle: 'text-ink',
    cardText: 'text-muted',
    iconBg: 'bg-brand-green-soft',
    iconColor: 'text-brand-green',
    accentText: 'text-brand-green',
    accentBorder: 'border-brand-green-line',
    accentBg: 'bg-brand-green-soft',
    gradientFrom: 'from-primary-600',
    gradientTo: 'to-primary-700',
    checkColor: 'text-brand-green',
    xColor: 'text-red-500',
  },
  marketplace: {
    background: 'gray',
    title: 'text-ink',
    subtitle: 'text-muted',
    eyebrow: 'text-brand-blue',
    card: 'bg-panel',
    cardBorder: 'border-line',
    cardTitle: 'text-ink',
    cardText: 'text-muted',
    iconBg: 'bg-brand-blue-soft',
    iconColor: 'text-brand-blue',
    accentText: 'text-brand-blue',
    accentBorder: 'border-brand-blue-line',
    accentBg: 'bg-brand-blue-soft',
    gradientFrom: 'from-sky-500',
    gradientTo: 'to-sky-600',
    checkColor: 'text-brand-blue',
    xColor: 'text-red-500',
  },
}
